import { render, staticRenderFns } from "./directory_download_links.vue?vue&type=template&id=f53ffab6"
import script from "./directory_download_links.vue?vue&type=script&lang=js"
export * from "./directory_download_links.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports